"use client";

import { AnimatePresence, motion } from "framer-motion";
import {
	type FeatureGuideId,
	useFeatureGuide,
} from "@/contexts/feature-guide-context";

interface FeatureGuideHintProps {
	guideId: FeatureGuideId;
	message: string;
	actionLabel: string;
	className?: string;
	bubbleClassName?: string;
	arrowClassName?: string;
}

export function FeatureGuideHint({
	guideId,
	message,
	actionLabel,
	className,
	bubbleClassName,
	arrowClassName,
}: FeatureGuideHintProps) {
	const { isGuideActive, dismissGuide } = useFeatureGuide();
	const isActive = isGuideActive(guideId);

	return (
		<AnimatePresence>
			{isActive && (
				<motion.div
					initial={{ opacity: 0, y: 10, scale: 0.9 }}
					animate={{ opacity: 1, y: 0, scale: 1 }}
					exit={{ opacity: 0, scale: 0.9 }}
					className={className}
				>
					<div
						className={`bg-light-primary text-white p-3 rounded-xl shadow-xl relative text-xs font-medium ${bubbleClassName ?? ""}`}
					>
						<div
							className={`absolute -top-1 right-3 w-3 h-3 bg-light-primary rotate-45 ${arrowClassName ?? ""}`}
						/>
						{message}
						<button
							onClick={() => dismissGuide(guideId)}
							className="block mt-2 font-bold underline cursor-pointer"
						>
							{actionLabel}
						</button>
					</div>
				</motion.div>
			)}
		</AnimatePresence>
	);
}
